import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

export class ArticleContent extends Component {
    // A new instance of this class is created for every element
    // that has the attribute data-component="LightBox".
    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
    }

    // This method is called after the constructor.
    public async init(): Promise<void> {
        let lightboxImages = this._element.querySelectorAll('.image-enlarge')

        for(let i=0;i<lightboxImages.length;i++){
            let componentId = 'Lb' + (<any>crypto).randomUUID().replace(/-/g, "").toString();
            // element is an HTMLElement that has the attribute data-component="LightBox"

            lightboxImages[i]?.querySelector('.enlarge-link')?.setAttribute('data-fancybox-trigger', componentId)
            lightboxImages[i]?.querySelector('a:nth-child(2)')?.setAttribute('data-fancybox', componentId)
        }
    }
}
// A component must be registered before it can be applied.
// The component must also be exported in one of the
// healio-custom-scripts ts files for it to be included in compilation.
// healio-custom-scripts-newsarea.ts was chosen for this one
// because it seems the most likely script to target all of
// the pages where this component might be in use.
ComponentFactory.registerComponent("ArticleContent", ArticleContent);